export const GET_SAVED_FILTERS_REQUEST = 'GET_SAVED_FILTERS_REQUEST';
export const GET_SAVED_FILTERS_SUCCESS = 'GET_SAVED_FILTERS_SUCCESS';
export const GET_SAVED_FILTERS_FAILURE = 'GET_SAVED_FILTERS_FAILURE';

export const SAVE_FILTER_REQUEST = 'SAVE_FILTER_REQUEST';
export const SAVE_FILTER_SUCCESS = 'SAVE_FILTER_SUCCESS';
export const SAVE_FILTER_FAILURE = 'SAVE_FILTER_FAILURE';

export const DELETE_FILTER_REQUEST = 'DELETE_FILTER_REQUEST';
export const DELETE_FILTER_SUCCESS = 'DELETE_FILTER_SUCCESS';
export const DELETE_FILTER_FAILURE = 'DELETE_FILTER_FAILURE';

export const SET_DEFAULT_FILTER_REQUEST = 'SET_DEFAULT_FILTER_REQUEST';
export const SET_DEFAULT_FILTER_SUCCESS = 'SET_DEFAULT_FILTER_SUCCESS';
export const SET_DEFAULT_FILTER_FAILURE = 'SET_DEFAULT_FILTER_FAILURE';

export const getSavedFiltersRequest = () => ({
    type: GET_SAVED_FILTERS_REQUEST
});

export const getSavedFiltersSuccess = screens => ({
    type: GET_SAVED_FILTERS_SUCCESS,
    payload: { screens }
});

export const getSavedFiltersFailure = err => ({
    type: GET_SAVED_FILTERS_FAILURE,
    error: err
});

export const saveFilterRequest = (screen, name, values) => ({
    type: SAVE_FILTER_REQUEST,
    payload: { screen, name, values }
});

export const saveFilterSuccess = (screen, presets) => ({
    type: SAVE_FILTER_SUCCESS,
    payload: { screen, presets }
});

export const saveFilterFailure = err => ({
    type: SAVE_FILTER_FAILURE,
    error: err
});

export const deleteFilterRequest = (screen, name) => ({
    type: DELETE_FILTER_REQUEST,
    payload: { screen, name }
});

export const deleteFilterSuccess = (screen, presets, defaultPreset) => ({
    type: DELETE_FILTER_SUCCESS,
    payload: { screen, presets, defaultPreset }
});

export const deleteFilterFailure = err => ({
    type: DELETE_FILTER_FAILURE,
    error: err
});

export const setDefaultFilterRequest = (screen, name) => ({
    type: SET_DEFAULT_FILTER_REQUEST,
    payload: { screen, name }
});

export const setDefaultFilterSuccess = (screen, defaultPreset) => ({
    type: SET_DEFAULT_FILTER_SUCCESS,
    payload: { screen, defaultPreset }
});

export const setDefaultFilterFailure = err => ({
    type: SET_DEFAULT_FILTER_FAILURE,
    error: err
});
